import { createTheme } from '@mui/material/styles';

import { baseTheme, getCommonThemesProps } from './baseTheme';
import { bancoValorColors } from './colors';

export const themeBancoValor = () => {
  const theme = baseTheme();

  const themeProperties = getCommonThemesProps(bancoValorColors);
  const { palette, components } = themeProperties;

  return createTheme({
    breakpoints: theme.breakpoints,
    palette,
    components,
    customLogo: {
      logo: 'BVALOR_LOGO',
      slogo: 'BVALOR_SLOGO',
      nlogo: 'BVALOR_NLOGO',
    },
    verticalBreakpoints: theme.verticalBreakpoints,
    typography: theme.typography,
  });
};

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV !== 'production') {
  window.theme = themeBancoValor();
}
